import React, { useEffect, useState } from 'react'
import cookie from "js-cookie"
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";
function MyBookingDetails() {

    const getCookieUser = cookie.get("user");
    const userInfo = getCookieUser ? JSON.parse(getCookieUser) : null;
    console.log(userInfo, "userInfo")
    const navigate = useNavigate()

    const [count, setCount] = useState([])

    const getItemsCount = async () => {
        try {
            const result = await axios.get(
              `${process.env.REACT_APP_API_URL}/allbookingForUser`,
              {
                headers: {
                  Authorization: `Bearer ${userInfo?.token}`,
                },
              }
            );
            console.log(result, "result")
            setCount(result.data.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getItemsCount()
    }, [])

    const viewUser = (id) => {
        navigate(`/MyBookDetailView/${id}`)
    }

    const deleteHandler = (id) => {
        try {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await axios.delete(
                      `${process.env.REACT_APP_API_URL}/deletebookingForAdmin/${id}`,
                      {
                        headers: {
                          Authorization: `Bearer ${userInfo?.token}`,
                        },
                      }
                    );
                    getItemsCount();
                    Swal.fire({
                        title: "Deleted!",
                        text: "Your file has been deleted.",
                        icon: "success",
                    });
                }
            });
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <>
            <div className="p-4 flex-grow-1" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <h2 className="mb-4">My Car Washing Services</h2>
                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Car Type</th>
                                <th>User Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Service Date</th>
                                <th>Country</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            {count?.map((e, index) => (
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{e?.carBookingId?.title}</td>
                                    <td>{e?.name}</td>
                                    <td>{e?.email}</td>
                                    <td>{e?.phoneNumber}</td>
                                    <td>{e?.date
                                        ? new Date(e.date).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : e?.createdAt
                                        ? new Date(e.createdAt).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "N/A"}</td>
                                    <td>{e?.timeSlot || "N/A"}</td>
                                    <td>{e?.vehicleType || "N/A"}</td>
                                    <td>{e?.vehicleNumber || "N/A"}</td>
                                    <td>
                                        {e?.status === 0 ? <span className="badge bg-warning">Pending</span> : 
                                         e?.status === 1 ? <span className="badge bg-success">Accepted</span> : 
                                         e?.status === 2 ? <span className="badge bg-danger">Rejected</span> :
                                         e?.status === 3 ? <span className="badge bg-info">In-Progress</span> :
                                         e?.status === 4 ? <span className="badge bg-primary">Completed</span> : ''}
                                    </td>
                                    <td>
                                        <button className="btn btn-sm btn-info me-2" onClick={() => viewUser(e?._id)}>
                                            <i className="fas fa-eye"></i> View
                                        </button>
                                        <button className="btn btn-sm btn-danger" onClick={() => deleteHandler(e?._id)}>
                                            <i className="fas fa-trash-alt"></i> Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default MyBookingDetails